import styled from 'styled-components';
import { Grid, Heading, Tabs, Tag, colors } from '@dexma/ui-components';
import { HomeHeaderProps } from 'adapter/in/common/components/Home/style';

export const StyledReportTableWrapper = styled.div`
    background-color: ${colors.gray100};
    padding-top: 24px;
    margin-top: -16px;
    padding-left: 30px;
    padding-right: 30px;

    > div:nth-child(2) > div {
        background-color: white !important;
        padding-bottom: 10px;
    }
`;

export const StyledReportTabs = styled(Tabs)`
    padding: 0 30px 0 30px;

    .ant-tabs-nav {
        margin-bottom: 0px;
        padding-left: 30px;
        padding-right: 30px;
        background-color: white;
    }
    .ant-table-wrapper {
        background-color: ${colors.gray100};
        padding: 0;
    }
`;

export const StyledHomeReportsGrid = styled(Grid)<HomeHeaderProps>`
    padding: 0px;
    height: 100%;
    background-color: ${colors.gray100};
    overflow-x: hidden;
    .heading {
        padding: 20px 0px;
        align-items: baseline;
        background-color: white;
    }
    .ant-table-thead > tr > th {
        border-top: 0px;
    }
`;

export const StyledReportsHeading = styled(Heading)`
    padding-left: 30px;
`;

export const StyledGreyTag = styled(Tag)`
    background-color: ${colors.gray50};
    border: 1px solid ${colors.gray200};
    color: ${colors.gray700};
`;
